import { type ComponentPropsWithRef, forwardRef, type ReactNode } from "react";
import * as styles from "./styles.css";

type Props = Omit<ComponentPropsWithRef<"input">, "type"> & {
  label?: ReactNode;
  onLabelClick?: (e: React.MouseEvent<HTMLLabelElement>) => void;
  labelClassName?: string;
  gaLabel?: string;
  gaAction?: string;
  hasError?: boolean;
  dataName?: string;
};

export const Checkbox = forwardRef<HTMLInputElement, Props>(
  (
    {
      name,
      value,
      id,
      label,
      onLabelClick,
      labelClassName,
      className,
      gaLabel,
      gaAction,
      defaultChecked,
      checked,
      disabled,
      hasError,
      onChange,
      dataName,
      "aria-label": ariaLabel,
    },
    ref,
  ) => {
    const inputElement = (
      <input
        type="checkbox"
        name={name}
        value={value}
        id={id}
        className={`${styles.variant[hasError ? "hasError" : "default"]} ${className || ""}`}
        data-ga-label={gaLabel}
        data-ga-action={gaAction}
        checked={checked}
        defaultChecked={defaultChecked}
        disabled={disabled}
        ref={ref}
        onChange={onChange}
        data-name={dataName}
        aria-label={typeof label === "string" ? label : ariaLabel}
      />
    );

    if (id && label) {
      return (
        /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */
        <label
          htmlFor={id}
          className={`${styles.label({ disabled })} ${labelClassName || ""}`}
          onClick={onLabelClick}
        >
          {inputElement}
          <span className={styles.labelText}>{label}</span>
        </label>
      );
    }

    return inputElement;
  },
);
Checkbox.displayName = "Checkbox";
